import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "diamondFilled"
const DiamondFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M11.438 9.938V21.871L1.74 9.938zM12.563 21.872V9.938H22.258zM22.294 8.813H16.264L19.02 2.992zM7.736 8.813H1.706L4.979 2.992zM14.486 8.813H9.514L12 3.564zM8.625 8.06 6.05 2.625H11.2zM15.375 8.06 12.8 2.625H17.95z" />
        </svg>
      }
    </span>
  )
}
export default DiamondFilledIcon
